type THydrationState = 'undefined' | 'started' | 'finished'

export interface IStorageState {
    hasHydrated: THydrationState
}

export const storageStoreDefaults: IStorageState = {
    hasHydrated: 'undefined',
}

export interface IStorageAction {
    setHasHydrated: (state: THydrationState) => void
}

export interface IStorageStore extends IStorageState, IStorageAction {}
